// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"c29aa0bb","219":"6519a2cc","346":"425d864b","624":"2c3c52de","797":"a9eb2e8e","862":"e5836f0f","876":"ffc6e86b"}[chunkId] + ".chunk.js";
};